// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "header-3jH8h";
var _4 = "title__wrapper-3ztY5";
var _5 = "title-B8_zw";
export { _1 as "__esModule", _2 as "mobile", _3 as "header", _4 as "title__wrapper", _5 as "title" }
export default { "__esModule": _1, "mobile": _2, "header": _3, "title__wrapper": _4, "title": _5 }
